<template>
  <div id="KeywordAdvertDetail" style="width: 100%; margin: 0 auto; padding: 20px; background: white">
    <div ref="header" class="header-box"></div>
    <div>
      <div ref="chartBox" class="chart-box"></div>
    </div>
    <div class="date-box">
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="placeholder"></span>
      <span class="date-weight" v-for="(item, index) in dates" :key="'a' + index">{{ item }}</span>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="投放广告表现" name="deliveryAd"></el-tab-pane>
      <el-tab-pane label="投放精准表现" name="deliveryTheKeywordAd"></el-tab-pane>
      <el-tab-pane label="投放其他表现" name="deliveryOtherKeywordAd"></el-tab-pane>
      <el-tab-pane label="其他广告表现" name="otherAd"></el-tab-pane>
      <el-tab-pane label="所有广告表现" name="allAd"></el-tab-pane>
      <el-tab-pane label="父商品广告表现" name="allProductDeliveryAd"></el-tab-pane>
    </el-tabs>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true" border show-summary>
      <el-table-column prop="dateDes" label="日期" width="80px" align="center"> </el-table-column>
      <el-table-column prop="asin" label="Asin" width="100px" align="center"> </el-table-column>
      <el-table-column prop="campaignName" label="广告名称" width="200px"> </el-table-column>
      <el-table-column prop="adGroupName" label="广告组" width="200px"> </el-table-column>
      <!-- <el-table-column prop="productName" label="产品名称" width="80px" sortable>
      </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="80px" sortable>
      </el-table-column>
      <el-table-column prop="model" label="机型" width="80px" sortable>
      </el-table-column> -->
      <el-table-column prop="delivery" label="投放词" width="200px" sortable>
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="goSearchkeywordMgmt1(scope.row)">{{ scope.row.delivery }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="matchType" label="匹配类型" width="80px" sortable>
        <template slot-scope="scope">
          {{ getMacthTypeText(scope.row.matchType) }}
        </template>
      </el-table-column>
      <el-table-column prop="searchKey" label="搜索词" width="200px" sortable>
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="goSearchkeywordMgmt2(scope.row)">{{ scope.row.searchKey }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="CPC" label="CPC" width="60px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.CPC.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Impressions" label="展现量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Clicks" label="点击量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.Spend.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售额" width="50px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.Sales.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Units" label="销售数量" width="60px" align="right" sortable> </el-table-column>
      <el-table-column prop="Conversion Rate" label="点击转化率" width="60px" align="right" sortable>
        <template slot-scope="scope">
          <div>{{ Math.round(scope.row["Conversion Rate"] * 10000) / 100 + "%" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="60px" align="right" sortable>
        <template slot-scope="scope">
          {{ scope.row.ROAS.toFixed(2) }}
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick">
    </el-pagination> -->
  </div>
</template>

<script>
import { requestModules } from "@r";
import * as echarts from "echarts";
import Utils from "../../../utils/utils.js";
import { products, colors, models } from "../../../utils/constant.js";
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 64 - 68,
      keyword: this.$route.query.keyword,
      productType: this.$route.query.productType,
      asin: this.$route.query.asin,
      date: this.$route.query.date,
      total: 0,
      pageCount: 1,
      dialogFormVisible: false,
      dialogVisible: false,
      totalPage: 1,
      advertData: [],
      keywordsText: "",
      multipleSelection: [],
      changeType: 1,
      keywordPrice: 0.1,
      quickPrice: 0.1,
      asin: this.$route.query.asin,
      entity: this.$route.query.entity,
      productTargetingId: this.$route.query.productTargetingId,
      sku: "",
      productColor: "",
      productModel: "",
      productList: products,
      colorList: colors,
      modelList: models,
      activeName: "deliveryAd",
      deliveryAds: [],
      deliveryTheKeywordAds: [],
      deliveryOtherKeywordAds: [],
      otherAds: [],
      allAds: [],
      allProductDeliveryAds: [],
      campaignName: this.$route.query.campaignName,
      adGroupName: this.$route.query.adGroupName,
      keyword: this.$route.query.keyword,
      params: {
        asin: this.$route.query.asin,
        pageSize: 1000,
        beginIndex: 0,
      },
      chart: null,
      dates: [],
      chartOptions: {
        legend: {
          top: 10,
          left: "center",
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = params[0].name + "<br/>";
            params.forEach(item => {
              if (item.seriesName === "访客") {
                const originalValue = item.value * this.visitScale;
                result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}%<br/>`;
              } else if (item.seriesName === "订单") {
                const originalValue = item.value * this.orderScale;
                result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}<br/>`;
              }
              result += `${item.marker} ${item.seriesName}: ${originalValue}%<br/>`;
            });
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      },
      keywordStatistic: {},
    };
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chartBox);
    this.initDefaultDate();

    let promiseList = [];
    promiseList.push(this.getDeliveryAdvertData());
    promiseList.push(this.getDeliveryOtherKeywordAdvertData());
    promiseList.push(this.getDeliveryTheKeywordAdvertData());
    promiseList.push(this.getOtherAdvertData());
    promiseList.push(this.getAllAdvertData());
    promiseList.push(this.getAllProductAdvertData());

    // Promise.all(promiseList).then(results => {
    //   this.initChart();
    // });

    this.fetchKeywordStatisticChatData();

    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    initDefaultDate() {
      // if (this.date) {
      //   return;
      // }

      let hours = new Date().getHours();
      let offset = 0;
      let usaFirstHour = 16;
      Utils.isDaylightSavingTime() && (usaFirstHour = 15);
      hours < usaFirstHour && (offset = 1);
      if (hours < usaFirstHour) {
        this.date = new Date(new Date().getTime() - offset * 24 * 60 * 60 * 1000).format("yyyy-MM-dd");
      } else {
        this.date = new Date().format("yyyy-MM-dd");
      }

      this.initChartDateList();
    },
    initChartDateList() {
      this.dates = [];
      for (let i = 29; i >= 0; i--) {
        let date = new Date(new Date(this.date).getTime() - i * 24 * 60 * 60 * 1000).format("MM-dd");
        this.dates.push(date);
      }
    },
    handleClick(tab, event) {
      let name = tab.name;
      if (name == "deliveryAd" && this.deliveryAds.length > 0) {
        this.advertData = this.deliveryAds;
      } else if (name == "otherAd" && this.otherAds.length > 0) {
        this.advertData = this.otherAds;
      } else if (name == "allAd" && this.allAds.length > 0) {
        this.advertData = this.allAds;
      } else if (name == "deliveryTheKeywordAd" && this.deliveryTheKeywordAds.length > 0) {
        this.advertData = this.deliveryTheKeywordAds;
      } else if (name == "deliveryOtherKeywordAd" && this.deliveryOtherKeywordAds.length > 0) {
        this.advertData = this.deliveryOtherKeywordAds;
      } else if (name == "allProductDeliveryAd" && this.allProductDeliveryAds.length > 0) {
        this.advertData = this.allProductDeliveryAds;
      }
    },
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 68;
    },
    getMacthTypeText(matchType) {
      let text = "";
      matchType == "EXACT" && (text = "精准");
      matchType == "PHRASE" && (text = "词组");
      matchType == "BROAD" && (text = "广泛");
      return text;
    },
    fetchKeywordStatisticChatData() {
      let params = { keyword: this.keyword, asin: this.asin };

      return requestModules.fetchKeywordStatisticChatData(params).then(res => {
        this.keywordStatistic = res.mdata;

        this.initStatisticChart();
      });
    },
    getDeliveryAdvertData() {
      let params = { ...this.params };
      params.campaignName = this.campaignName;
      params.adGroupName = this.adGroupName;
      params.delivery = this.keyword;

      return requestModules.fetchDetailKeywordAds(params).then(res => {
        this.advertData = res.ldata;
        this.deliveryAds = res.ldata;
      });
    },
    getDeliveryTheKeywordAdvertData() {
      let params = { ...this.params };
      params.campaignName = this.campaignName;
      params.adGroupName = this.adGroupName;
      params.searchKey = this.keyword;
      params.delivery = this.keyword;

      return requestModules.fetchDetailKeywordAds(params).then(res => {
        this.advertData = res.ldata;
        this.deliveryTheKeywordAds = res.ldata;
      });
    },
    getDeliveryOtherKeywordAdvertData() {
      let params = { ...this.params };
      params.campaignName = this.campaignName;
      params.adGroupName = this.adGroupName;
      params.delivery = this.keyword;
      params.isOtherKeyword = true;

      return requestModules.fetchDetailKeywordAds(params).then(res => {
        this.advertData = res.ldata;
        this.deliveryOtherKeywordAds = res.ldata;
      });
    },
    getOtherAdvertData() {
      let params = { ...this.params };
      params.campaignName = this.campaignName;
      params.adGroupName = this.adGroupName;
      params.searchKey = this.keyword;
      params.isOtherAds = true;

      return requestModules.fetchDetailKeywordAds(params).then(res => {
        this.otherAds = res.ldata;
      });
    },
    getAllAdvertData() {
      let params = { ...this.params };
      params.searchKey = this.keyword;
      return requestModules.fetchDetailKeywordAds(params).then(res => {
        this.allAds = res.ldata;
      });
    },
    getAllProductAdvertData() {
      let params = { ...this.params };
      params.campaignName = this.campaignName;
      // params.adGroupName = this.adGroupName;
      params.delivery = this.keyword;
      delete params.asin;
      return requestModules.fetchDetailKeywordAds(params).then(res => {
        this.allProductDeliveryAds = res.ldata;
      });
    },
    initStatisticChart() {
      let chartOptions = {
        selectedMode: true,
        legend: {
          top: 10,
          left: "center",
          selected: {
            "昨日展现量": false,
            "昨日订单": false,
            "昨日销售额": false,
            "昨日广告": false,
            "昨日商品数": false,
            "昨日点击数": false,
            "昨日ACOS": false,
            "昨日ROAS": false,
            "昨日点击率": false,
            "昨日转化率": false,
            "昨日7日目标SKU订单数": false,
            "昨日7日其他SKU订单数": false,
            "昨日CPC": false,
            "近7日展现量": false,
            "近7日订单": false,
            "近7日销售额": false,
            "近7日广告": false,
            "近7日商品数": false,
            "近7日点击数": false,
            "近7日ACOS": false,
            "近7日ROAS": false,
            "近7日点击率": false,
            "近7日转化率": false,
            "近7日7日目标SKU订单数": false,
            "近7日7日其他SKU订单数": false,
            "近7日CPC": false,
            "近14日展现量": false,
            "近14日订单": false,
            "近14日销售额": false,
            "近14日广告": false,
            "近14日商品数": false,
            "近14日点击数": false,
            "近14日ACOS": false,
            "近14日ROAS": false,
            "近14日点击率": false,
            "近14日转化率": false,
            "近14日7日目标SKU订单数": false,
            "近14日7日其他SKU订单数": false,
            "近14日CPC": false,
            "近30日展现量": false,
            "近30日订单": false,
            "近30日销售额": false,
            "近30日广告": false,
            "近30日商品数": false,
            "近30日点击数": false,
            "近30日ACOS": false,
            "近30日ROAS": false,
            "近30日点击率": false,
            "近30日转化率": false,
            "近30日7日目标SKU订单数": false,
            "近30日7日其他SKU订单数": false,
            "近30日CPC": false,
            "近90日展现量": true,
            "近90日订单": false,
            "近90日销售额": false,
            "近90日广告": false,
            "近90日商品数": false,
            "近90日点击数": false,
            "近90日ACOS": false,
            "近90日ROAS": false,
            "近90日点击率": false,
            "近90日转化率": false,
            "近90日7日目标SKU订单数": false,
            "近90日7日其他SKU订单数": false,
            "近90日CPC": false,
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // 使用 formatter 函数将值转换为百分比
            formatter: function (value) {
              return value;
            },
          },
        },
        series: [],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = params[0].name + "<br/>";
            params.forEach(item => {
              if (item.value === undefined) {
              } else {
                let originalValue = 0;
                originalValue = item.value;
                if (item.seriesName.indexOf("转化率") != -1 || item.seriesName.indexOf("点击率") != -1) {
                  result += `${item.marker} ${item.seriesName}: ${(originalValue * 100).toFixed(2)}%<br/>`;
                } else if (item.seriesName.indexOf("CPC") != -1 || item.seriesName.indexOf("ROAS") != -1 || item.seriesName.indexOf("ACOS") != -1 || item.seriesName.indexOf("花费") != -1 || item.seriesName.indexOf("广告") != -1 || item.seriesName.indexOf("销售额") != -1) {
                  result += `${item.marker} ${item.seriesName}: ${parseFloat(originalValue.toFixed(2))}<br/>`;
                } else {
                  result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}<br/>`;
                }

                //           propertyNameMap.set("Impressions", "展现量");
                // propertyNameMap.set("Orders", "订单");
                // propertyNameMap.set("Sales", "销售额");
                // propertyNameMap.set("Spend", "广告");
                // propertyNameMap.set("Units", "商品数");
                // propertyNameMap.set("Clicks", "点击数");
                // propertyNameMap.set("CPC", "CPC");
                // propertyNameMap.set("ROAS", "ROAS");
                // propertyNameMap.set("ACOS", "ACOS");
                // propertyNameMap.set("ClickRate", "点击率");
                // propertyNameMap.set("ConversionRate", "转化率");
                // propertyNameMap.set("Total7DayAdSkuCount", "7日目标SKU订单数");
                // propertyNameMap.set("Total7DayOtherSkuCount", "7日其他SKU订单数");
              }
            });
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      };

      chartOptions.xAxis.data = this.dates;
      // chartOptions.series = [
      //   {
      //     data: this.keywordStatistic.keywordAllPerformance.,
      //     type: "line",
      //     smooth: true,
      //     name: "投放展现量",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Impressions"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他展现量",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Impressions"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计展现量",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Clicks"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放点击数",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Clicks"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他点击数",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Clicks"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计点击数",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Click-through Rate"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放点击率",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Click-through Rate"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他点击率",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Click-through Rate"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计点击率",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Conversion Rate"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放转化率",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Conversion Rate"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他转化率",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Conversion Rate"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计转化率",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Spend"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放花费",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Spend"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他花费",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Spend"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计花费",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "ROAS"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放ROAS",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "ROAS"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他ROAS",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "ROAS"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计ROAS",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "CPC"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放CPC",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "CPC"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他CPC",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "CPC"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计CPC",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Sales"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放销售额",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Sales"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他销售额",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Sales"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计销售额",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Orders"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放订单数",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Orders"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他订单数",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Orders"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计订单数",
      //   },
      //   {
      //     data: this.initChartData(this.deliveryAds, "Units"),
      //     type: "line",
      //     smooth: true,
      //     name: "投放销售数量",
      //   },
      //   {
      //     data: this.initChartData(this.otherAds, "Units"),
      //     type: "line",
      //     smooth: true,
      //     name: "其他销售数量",
      //   },
      //   {
      //     data: this.initChartData(this.allAds, "Units"),
      //     type: "line",
      //     smooth: true,
      //     name: "合计销售数量",
      //   },
      // ];

      chartOptions.series = this.initChatSeries();

      this.chart.setOption(chartOptions);
    },

    initChatSeries() {
      let chatPropertyList = [
        "lastDayImpressions",
        "last7DayImpressions",
        "last14DayImpressions",
        "last30DayImpressions",
        "last90DayImpressions",

        "lastDayOrders",
        "last7DayOrders",
        "last14DayOrders",
        "last30DayOrders",
        "last90DayOrders",
        "lastDaySales",
        "last7DaySales",
        "last14DaySales",
        "last30DaySales",
        "last90DaySales",
        "lastDaySpend",
        "last7DaySpend",
        "last14DaySpend",
        "last30DaySpend",
        "last90DaySpend",
        "lastDayUnits",
        "last7DayUnits",
        "last14DayUnits",
        "last30DayUnits",
        "last90DayUnits",
        "lastDayClicks",
        "last7DayClicks",
        "last14DayClicks",
        "last30DayClicks",
        "last90DayClicks",
        "lastDayTotal7DayAdSkuCount",
        "last7DayTotal7DayAdSkuCount",
        "last14DayTotal7DayAdSkuCount",
        "last30DayTotal7DayAdSkuCount",
        "last90DayTotal7DayAdSkuCount",
        "lastDayTotal7DayOtherSkuCount",
        "last7DayTotal7DayOtherSkuCount",
        "last14DayTotal7DayOtherSkuCount",
        "last30DayTotal7DayOtherSkuCount",
        "last90DayTotal7DayOtherSkuCount",
        "lastDayCPC",
        "last7DayCPC",
        "last14DayCPC",
        "last30DayCPC",
        "last90DayCPC",
        "lastDayACOS",
        "last7DayACOS",
        "last14DayACOS",
        "last30DayACOS",
        "last90DayACOS",
        "lastDayROAS",
        "last7DayROAS",
        "last14DayROAS",
        "last30DayROAS",
        "last90DayROAS",
        "lastDayClickRate",
        "last7DayClickRate",
        "last14DayClickRate",
        "last30DayClickRate",
        "last90DayClickRate",
        "lastDayConversionRate",
        "last7DayConversionRate",
        "last14DayConversionRate",
        "last30DayConversionRate",
        "last90DayConversionRate",
      ];
      let propertyNameMap = new Map();
      propertyNameMap.set("lastDay", "昨日");
      propertyNameMap.set("last7Day", "近7日");
      propertyNameMap.set("last14Day", "近14日");
      propertyNameMap.set("last30Day", "近30日");
      propertyNameMap.set("last90Day", "近90日");
      propertyNameMap.set("Impressions", "展现量");
      propertyNameMap.set("Orders", "订单");
      propertyNameMap.set("Sales", "销售额");
      propertyNameMap.set("Spend", "广告");
      propertyNameMap.set("Units", "商品数");
      propertyNameMap.set("Clicks", "点击数");
      propertyNameMap.set("CPC", "CPC");
      propertyNameMap.set("ROAS", "ROAS");
      propertyNameMap.set("ACOS", "ACOS");
      propertyNameMap.set("ClickRate", "点击率");
      propertyNameMap.set("ConversionRate", "转化率");
      propertyNameMap.set("Total7DayAdSkuCount", "7日目标SKU订单数");
      propertyNameMap.set("Total7DayOtherSkuCount", "7日其他SKU订单数");

      let series = [];
      chatPropertyList.forEach(p => {
        let list = this.splitByFirstDay(p);
        let lineName = "";
        list.length > 0 && (lineName += propertyNameMap.get(list[0]));
        list.length > 1 && (lineName += propertyNameMap.get(list[1]));

        series.push({
          data: this.keywordStatistic.keywordAllPerformance[p],
          type: "line",
          smooth: true,
          name: lineName,
        });
      });

      return series;
    },
    goSearchkeywordMgmt1(row) {
      window.open("/client/searchKeywordMgmt?delivery=" + row.delivery + "&matchType=" + row.matchType + "&productType=" + this.productType + "&isDelivery=''");
    },
    goSearchkeywordMgmt2(row) {
      window.open("/client/searchKeywordMgmt?searchKeyword=" + row.searchKey + "&matchType=" + row.matchType + "&productType=" + this.productType + "&isDelivery=''");
    },
    splitByFirstDay(str) {
      // 找到第一个 "Day" 出现的位置
      const index = str.indexOf("Day");

      // 如果找到 "Day"，进行分割
      if (index !== -1) {
        const firstPart = str.substring(0, index + 3); // 包含 "Day"
        const secondPart = str.substring(index + 3); // 从 "Day" 之后开始
        return [firstPart, secondPart];
      }

      // 如果字符串中不包含 "Day"，返回原字符串
      return [str];
    },

    initChart() {
      let chartOptions = {
        legend: {
          top: 10,
          left: "center",
          selected: {
            投放展现量: true,
            其他展现量: true,
            合计展现量: true,
            投放点击数: false,
            其他点击数: false,
            合计点击数: false,
            投放点击率: false,
            其他点击率: false,
            合计点击率: false,
            投放转化率: false,
            其他转化率: false,
            合计转化率: false,
            投放花费: false,
            其他花费: false,
            合计花费: false,
            投放CPC: false,
            其他CPC: false,
            合计CPC: false,
            投放ROAS: false,
            其他ROAS: false,
            合计ROAS: false,
            投放销售额: false,
            其他销售额: false,
            合计销售额: false,
            投放订单数: false,
            其他订单数: false,
            合计订单数: false,
            投放销售数量: false,
            其他销售数量: false,
            合计销售数量: false,
          },
        },
        xAxis: {
          type: "category",
          data: [],
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // 使用 formatter 函数将值转换为百分比
            formatter: function (value) {
              return value;
            },
          },
        },
        series: [],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          extraCssText: "width: 170px",
          formatter: function (params) {
            let result = params[0].name + "<br/>";
            params.forEach(item => {
              if (item.value === undefined) {
              } else {
                let originalValue = 0;
                originalValue = item.value;
                if (item.seriesName.indexOf("成交率") != -1 || item.seriesName.indexOf("点击率率") != -1) {
                  result += `${item.marker} ${item.seriesName}: ${(originalValue * 100).toFixed(2)}%<br/>`;
                } else if (item.seriesName.indexOf("CPC") != -1 || item.seriesName.indexOf("花费") != -1 || item.seriesName.indexOf("销售额") != -1 || item.seriesName.indexOf("ROAS") != -1) {
                  result += `${item.marker} ${item.seriesName}: ${parseFloat(originalValue.toFixed(2))}<br/>`;
                } else {
                  result += `${item.marker} ${item.seriesName}: ${parseInt(originalValue)}<br/>`;
                }
              }
            });
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: false,
            },
            brush: {
              type: ["lineX", "clear"],
            },
          },
        },
        brush: {
          xAxisIndex: "all",
          brushLink: "all",
          outOfBrush: {
            colorAlpha: 0.1,
          },
        },
      };

      chartOptions.xAxis.data = this.dates;
      chartOptions.series = [
        {
          data: this.initChartData(this.deliveryAds, "Impressions"),
          type: "line",
          smooth: true,
          name: "投放展现量",
        },
        {
          data: this.initChartData(this.otherAds, "Impressions"),
          type: "line",
          smooth: true,
          name: "其他展现量",
        },
        {
          data: this.initChartData(this.allAds, "Impressions"),
          type: "line",
          smooth: true,
          name: "合计展现量",
        },
        {
          data: this.initChartData(this.deliveryAds, "Clicks"),
          type: "line",
          smooth: true,
          name: "投放点击数",
        },
        {
          data: this.initChartData(this.otherAds, "Clicks"),
          type: "line",
          smooth: true,
          name: "其他点击数",
        },
        {
          data: this.initChartData(this.allAds, "Clicks"),
          type: "line",
          smooth: true,
          name: "合计点击数",
        },
        {
          data: this.initChartData(this.deliveryAds, "Click-through Rate"),
          type: "line",
          smooth: true,
          name: "投放点击率",
        },
        {
          data: this.initChartData(this.otherAds, "Click-through Rate"),
          type: "line",
          smooth: true,
          name: "其他点击率",
        },
        {
          data: this.initChartData(this.allAds, "Click-through Rate"),
          type: "line",
          smooth: true,
          name: "合计点击率",
        },
        {
          data: this.initChartData(this.deliveryAds, "Conversion Rate"),
          type: "line",
          smooth: true,
          name: "投放转化率",
        },
        {
          data: this.initChartData(this.otherAds, "Conversion Rate"),
          type: "line",
          smooth: true,
          name: "其他转化率",
        },
        {
          data: this.initChartData(this.allAds, "Conversion Rate"),
          type: "line",
          smooth: true,
          name: "合计转化率",
        },
        {
          data: this.initChartData(this.deliveryAds, "Spend"),
          type: "line",
          smooth: true,
          name: "投放花费",
        },
        {
          data: this.initChartData(this.otherAds, "Spend"),
          type: "line",
          smooth: true,
          name: "其他花费",
        },
        {
          data: this.initChartData(this.allAds, "Spend"),
          type: "line",
          smooth: true,
          name: "合计花费",
        },
        {
          data: this.initChartData(this.deliveryAds, "ROAS"),
          type: "line",
          smooth: true,
          name: "投放ROAS",
        },
        {
          data: this.initChartData(this.otherAds, "ROAS"),
          type: "line",
          smooth: true,
          name: "其他ROAS",
        },
        {
          data: this.initChartData(this.allAds, "ROAS"),
          type: "line",
          smooth: true,
          name: "合计ROAS",
        },
        {
          data: this.initChartData(this.deliveryAds, "CPC"),
          type: "line",
          smooth: true,
          name: "投放CPC",
        },
        {
          data: this.initChartData(this.otherAds, "CPC"),
          type: "line",
          smooth: true,
          name: "其他CPC",
        },
        {
          data: this.initChartData(this.allAds, "CPC"),
          type: "line",
          smooth: true,
          name: "合计CPC",
        },
        {
          data: this.initChartData(this.deliveryAds, "Sales"),
          type: "line",
          smooth: true,
          name: "投放销售额",
        },
        {
          data: this.initChartData(this.otherAds, "Sales"),
          type: "line",
          smooth: true,
          name: "其他销售额",
        },
        {
          data: this.initChartData(this.allAds, "Sales"),
          type: "line",
          smooth: true,
          name: "合计销售额",
        },
        {
          data: this.initChartData(this.deliveryAds, "Orders"),
          type: "line",
          smooth: true,
          name: "投放订单数",
        },
        {
          data: this.initChartData(this.otherAds, "Orders"),
          type: "line",
          smooth: true,
          name: "其他订单数",
        },
        {
          data: this.initChartData(this.allAds, "Orders"),
          type: "line",
          smooth: true,
          name: "合计订单数",
        },
        {
          data: this.initChartData(this.deliveryAds, "Units"),
          type: "line",
          smooth: true,
          name: "投放销售数量",
        },
        {
          data: this.initChartData(this.otherAds, "Units"),
          type: "line",
          smooth: true,
          name: "其他销售数量",
        },
        {
          data: this.initChartData(this.allAds, "Units"),
          type: "line",
          smooth: true,
          name: "合计销售数量",
        },
      ];

      this.chart.setOption(chartOptions);
    },
    initChartData(ads, key) {
      let list = [];
      for (let i = 29; i >= 0; i--) {
        let date = new Date(new Date(this.date).getTime() - i * 24 * 60 * 60 * 1000).format("yyyy-MM-dd");
        let dateAds = ads.filter(ad => ad.date == date);
        if (dateAds.length == 0) {
          list.push(null);
        } else {
          let value = 0;
          dateAds.forEach(ad => (value += ad[key]));
          console.log(dateAds.length, value);
          list.push(value);
        }
      }
      return list;
    },
    // handlerPageChange() {
    //   let pageNav = this.$refs.pageNav;
    //   let internalCurrentPage = pageNav.internalCurrentPage;
    //   this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
    //   this.getAdvertData();
    // },
  },
  computed: {
    tableData() {
      let list = [...this.advertData];
      return list;
    },
  },
};
</script>

<style lang="scss">
#KeywordAdvertDetail {
  .date-box {
    span {
      display: inline-block;
      font-size: 12px;
      width: 43px;
      text-align: right;
    }
    .type-label,
    .weight {
      width: 60px;
    }
    .placeholder {
      width: 60px;
    }
  }
  .chart-box {
    width: 100%;
    height: 400px;
  }
  .weight-box {
    margin-bottom: 20px;
  }
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 5px;
    padding-right: 2px;
    line-height: 14px;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
